import { type FilterObject, convertUrlFiltersToES, encodeFilters } from 'app/filter.utils'

/** The sidebar's own composition: encode like the URL does, then convert like the table does. */
export function filtersToSearch(filters: FilterObject[], join?: string | null): string {
  return convertUrlFiltersToES(encodeFilters(filters), join ?? undefined).join(` `)
}
